import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: theme.palette.primary.main
    },
    formControl: {
      minWidth: 120,
    },
    dialogTitle: {
      fontFamily: "Lato",
      fontSize: "1.5rem",
      fontWeight: 600,
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: 1.21,
      letterSpacing: "normal",
      color: theme.palette.primary.main
    },
  })
);
